
  <!--<printheaderview [hasimage]="1"></printheaderview>-->
  <div class="pagebrk">
    <div class="row">
      <div class="col-print-12 padding-left-0px">
        <div class="card">
          <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
          <div class="card-body padding-top-0px padding-bottom-0px">
            <div class="row">
              <div class="col-print-11 text-align-center">
                <label class="font-familyhead">Cryo Storage</label>
              </div>
            </div>
            <div class="row bordertop border-bot-1px margin-left-0px">
              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family">Owner:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-weight-bold font-family float-left">{{Owner}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family">Gender/Age:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left">{{Gender}}/{{Age}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family">Patient ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left">{{PatientID}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family">Infertility Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left">{{Infertility}}</label>
                  </div>
                </div>
              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family">Cycle:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left">{{CycleType}} ({{CycleNo}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family">Protocol:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left">{{Protocol}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family">Protocol Start:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family">Protocol End:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left"></label>
              </div>
            </div>

            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-bold">Oocyte Storage</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>



            <div class="row margin-left-0px">
              <div class="col-print-8">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <thead>
                        <tr>

                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                            Well#
                          </th>

                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Morphology
                          </th>
                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Storage
                          </th>
                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Details
                          </th>
                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let l of EggList">
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.WellNo}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Morphology}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StorageUnitType}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StorageUnitDetails}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Status}}</td><!--{{l.RecordStatus}}-->
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>


            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left"></label>
              </div>
            </div>

            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-bold">Sperm Storage</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>


            <div class="row margin-left-0px">
              <div class="col-print-8">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <thead>
                        <tr>
                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                            Date
                          </th>

                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                            Storage Type
                          </th>

                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Volume
                          </th>
                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Storage Unit Details
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let l of CurrentIvfSpermStoreByCodeController">
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.LastUpdateDate| date:'MMM-dd-yyyy'}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StorageUnitType}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Volume}}{{l.VolumeUnits}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StorageUnitDetails}}</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>

            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>


            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-bold">Embryo Storage</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>

            <div class="row margin-left-0px">
              <div class="col-print-8">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <thead>
                        <tr>

                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                            Well#
                          </th>

                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Grade
                          </th>
                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Storage
                          </th>
                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Details
                          </th>
                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let l of EmbryoList">
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.WellNo}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Grade}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StorageUnitType}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StorageUnitDetails}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Status}}</td><!--{{l.RecordStatus}}-->
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>

            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-7">
                <label class="margin-bottom-0px font-family">Surgeon</label>
              </div>
              <div class="col-print-5">
                <label class="margin-bottom-0px font-family">Assistant Surgeon</label>
              </div>
            </div>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-7">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-4 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center"></label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family"></label>
                  </div>
                </div>
              </div>
              <div class="col-print-5">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center"></label>
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family"></label>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <!--<printfooterview [Sign1]="FpSign1" [Sign2]="FpSign2"></printfooterview>-->

